import { cloneDeep } from 'lodash';
import { AnyAction, Reducer } from 'redux';
import { LookUpState, PayerLookUpState } from '../models/lookUpModel';
import actionType from './../types/lookUpType';

const lookUpState: LookUpState = {
  pastHistory: [],
  diagnosisType: [],
  proposedLineOfTreatment: [],
  designation: [],
  relation: [],
  payerClaimStatuses: [],
  payerRIClaimStatuses: [],
  grievanceStatus: [],
  allInsurers: [],
  allGrievances: [],
  badDiagnosis: [],
  badTreatment: [],
  onMailPayers: [],
  roleMaster: [],
  courierService: [],
  synonymValue: '',
  treatmentValue: '',
  diagnosisValue: '',
  diagnosisDynamicLookup: [],
  procedureDynamicLookup: [],
  grievanceLookup: [],
};

const payerLookUpState: PayerLookUpState = {};

const setLookUp = (state: LookUpState, { payload }: AnyAction): LookUpState => ({ ...state, ...payload });

const clearLookupState = (): LookUpState => (cloneDeep(lookUpState));

const setPayerLookUp = (state: PayerLookUpState, { payload }: AnyAction): PayerLookUpState => {
  return { ...state, ...payload };
};

const setInpatientStatus = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.payerClaimStatuses = payload;
  return { ...updatedState };
};

const setAllInpatientStatus = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.payerAllClaimStatuses = payload;
  return { ...updatedState };
};

const setDiagnosisValues = (state: PayerLookUpState, { payload }: AnyAction): PayerLookUpState => {
  const updatedState = state;
  updatedState.diagnosisMasterLookup = payload;
  return { ...updatedState };
};

const setRIInpatientStatus = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.payerRIClaimStatuses = payload;
  return { ...updatedState };
};

const setGrievanceStatus = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.grievanceStatus = payload;
  return { ...updatedState };
};

const setAllInsurers = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.allInsurers = payload;
  return { ...updatedState };
};

const setAllGrievance = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.allGrievances = payload;
  return { ...updatedState };
};

const setAllGrievanceLookup = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.grievanceLookup = payload;
  return { ...updatedState };
};

const setAllOnMailPayers = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  return {
    ...state,
    onMailPayers: payload,
  };
};
const setSynonymValue = (state: LookUpState, { synonymValue }: AnyAction): LookUpState => ({
  ...state, ...{ synonymValue },
});

const setBillDetail = (state: LookUpState, { payload }: AnyAction): LookUpState => {
  const updatedState = state;
  updatedState.billDetailData = payload;
  return { ...updatedState };
};

export const clearPayerLookUp = (): PayerLookUpState => ({});

export const lookUpReducer: Reducer<LookUpState> = (
  state: LookUpState = lookUpState,
  action: AnyAction,
): LookUpState => {
  switch (action.type) {
    case actionType.SET_LOOK_UP_VALUES:
      return setLookUp(state, action);
    case actionType.SET_PAYER_CLAIM_STATUSES:
      return setInpatientStatus(state, action);
    case actionType.SET_ALL_PAYER_CLAIM_STATUSES:
      return setAllInpatientStatus(state, action);
    case actionType.SET_GRIEVANCE_STATUSES:
      return setGrievanceStatus(state, action);
    case actionType.SET_REIMBURSEMENT_PAYER_CLAIM_STATUSES:
      return setRIInpatientStatus(state, action);
    case actionType.SET_ALL_ONMAIL_PAYERS:
      return setAllOnMailPayers(state, action);
    case actionType.SET_ALL_INSURERS:
      return setAllInsurers(state, action);
    case actionType.SET_ALL_GRIEVANCE:
      return setAllGrievance(state, action);
    case actionType.SET_ALL_GRIEVANCE_LOOKUP:
      return setAllGrievanceLookup(state, action);
    case actionType.UPDATE_ROLE_MASTER:
      return {
        ...state,
        roleMaster: action.payload,
      };
    case actionType.SYNONYM_TREATMENT_DATA_VALUE:
      return {
        ...state,
        treatmentValue: action.payload,
      };
    case actionType.SYNONYM_DIAGNOSIS_DATA_VALUE:
      return {
        ...state,
        diagnosisValue: action.payload,
      };
    case actionType.CLEAR_LOOKUP:
      return clearLookupState();
    case actionType.SYNONYM_TREATMENT_VALUE:
      return setSynonymValue(state, action);
    case actionType.FETCH_DIAGNOSIS_LOOKUP_REQUEST:
      return {
        ...state,
        diagnosisDynamicLookup: action.payload,
      };
    case actionType.FETCH_LOOKUP_BYVALUE_REQUEST:
      if (action.payload?.masterType === 'Procedure') {
        return {
          ...state,
          procedureDynamicLookup: action.payload?.dynamicLookup,
        };
      } else if (action.payload?.masterType === 'Diagnosis') {
        return {
          ...state,
          diagnosisDynamicLookup: action.payload?.dynamicLookup,
        };
      }
      return state;
    case actionType.SET_BILL_DETAIL:
      return setBillDetail(state, action);
    default:
      return state;
  }
};

export const payerLookUpReducer: Reducer<PayerLookUpState> = (
  state: PayerLookUpState = payerLookUpState,
  action: AnyAction,
): PayerLookUpState => {
  switch (action.type) {
    case actionType.SET_PAYER_LOOK_UP_VALUES:
      return setPayerLookUp(state, action);
    case actionType.SET_DIAGNOSIS_VALUES:
      return setDiagnosisValues(state, action);
    case actionType.CLEAR_PAYER_LOOKUP:
      return clearPayerLookUp();
    default:
      return state;
  }
};
